// ----------------------------------------------------------------------------
// Nombre del Programa : VistaSolicitud
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para la vista y funciones de la vista previa de una solicitud de comunicado
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import useAutosizeTextArea from '../../../Utilidades/useAutosizeTextArea';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  SolicitudComunicadosProps,
  SolicitudEstatusProps,
  TipoMensajeProps,
} from '../../../interfaces/solicitudComunicadosInterfaces';
import { StatusAlertService } from 'react-status-alert';
import { getSolicitud, getSolicitudesEstatus, getSolicitudesMensajes, postEstatusSolicitudes } from '../../../Services/SolicitudComunicadosService';

export const VistaSolicitud = ({ idSolicitud }) => {
  const [solicitud, setSolicitud] = useState<SolicitudComunicadosProps>();
  const [estatusSolicitud, setEstatusSolicitud] = useState<
    SolicitudEstatusProps[]
  >([]);
  const [tipoMensajes, setTipoMensajes] = useState<TipoMensajeProps[]>([]);
  const [estatusSeleccionado, setEstatusSeleccionado] = useState('0');
  const [descripcionSolicitud, setDescripcionSolicitud] = useState('');

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  useAutosizeTextArea(textAreaRef.current, descripcionSolicitud);

  const navigate = useNavigate();

  useEffect(() => {
    cargarSolicitud(idSolicitud!);
    cargarEstatusSolicitud();
    cargarMensajes();
  }, []);

  const cargarSolicitud = async (id: String) => {
    const response: any = await getSolicitud(id).catch(({ response }) => {
      const { data } = response;
      let noSolicitud = {} as SolicitudComunicadosProps;
      setSolicitud(noSolicitud);
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      setSolicitud(response.data.data[0]);
      setEstatusSeleccionado(
        response.data.data[0].solicitudestatus_id.solicitudestatus_id
      );
      setDescripcionSolicitud(response.data.data[0].descripcion);
    }
  };

  const cargarEstatusSolicitud = async () => {
    const response: any = await getSolicitudesEstatus().catch(({ response }) => {
      const { data } = response;
      const noEstatus: SolicitudEstatusProps[] = [];
      setEstatusSolicitud(noEstatus);
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      setEstatusSolicitud(response.data.data);
    }
  };

  const cargarMensajes = async () => {
    const response: any = await getSolicitudesMensajes().catch(({ response }) => {
      const { data } = response;
      const nodata: TipoMensajeProps[] = [];
      setTipoMensajes(nodata);
    });
    if (response.data && response.data.data) {
      setTipoMensajes(response.data.data);
    }
  };

  const actualizarEstatusSolicitud = async (idp: string) => {
    setEstatusSeleccionado(idp);
    let estatusActualizar = {} as SolicitudEstatusProps;
    estatusActualizar.solicitudestatus_id = Number(idp);

    solicitud!.solicitudestatus_id = estatusActualizar;

    const response: any = await postEstatusSolicitudes(solicitud!).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      StatusAlertService.showSuccess('Actualizado Correctamente');
    }
  };

  return (
    <>
      <div>
        {solicitud ? (
          <Row className="mt-3 agregar-usuario">
            <Col>
              <Row className="titulo">
                <Col className="heading-1">Solicitud de Comunicado</Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12} className="minimocolumna">
                  <Form.Label>Nombre</Form.Label>
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder=""
                      aria-label="Search"
                      disabled={true}
                      value={solicitud!.nombreSolicito}
                      className="cajabordeabajo"
                    />
                  </Form>
                </Col>
              </Row>
              {solicitud!.areaSolicito ?
                <Row className="mt-3">
                  <Col sm={12} className="minimocolumna">
                    <Form.Label>Area</Form.Label>
                    <Form className="d-flex">
                      <Form.Control
                        type="search"
                        placeholder=""
                        aria-label="Search"
                        disabled={true}
                        value={solicitud!.areaSolicito}
                        className="cajabordeabajo"
                      />
                    </Form>
                  </Col>
                </Row>
                : ''}
              <Row className="mt-3">
                <Col sm={6} className="minimocolumna">
                  <Form.Label>Tipo de necesidad</Form.Label>
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder=""
                      aria-label="Search"
                      disabled={true}
                      value={solicitud!.tiponecesidad_id!.nombre}
                      className="cajabordeabajo"
                    />
                  </Form>
                </Col>
                <Col sm={6} className="minimocolumna">
                  <Form.Label>Estado</Form.Label>
                  <Form className="d-flex">
                    <Form.Select
                      className="borde-rojo"
                      value={estatusSeleccionado}
                      onChange={(e) =>
                        actualizarEstatusSolicitud(e.target.value)
                      }
                    >
                      {estatusSolicitud.length > 0 ? (
                        estatusSolicitud.map((estatus, index) => (
                          <option
                            key={estatus.solicitudestatus_id}
                            value={estatus.solicitudestatus_id}
                          >
                            {estatus.nombre}
                          </option>
                        ))
                      ) : (
                        <option value="0"></option>
                      )}
                    </Form.Select>
                  </Form>
                </Col>
              </Row>
              {solicitud!.tiponecesidad_id!.tiponecesidad_id === 2 ? (
                <div>
                  <Row className="mt-3">
                    <Col sm={6} className="minimocolumna">
                      <Form.Label>Tipo de mensaje</Form.Label>
                      <Form className="d-flex">
                        <Form.Control
                          type="search"
                          placeholder=""
                          aria-label="Search"
                          disabled={true}
                          value={solicitud!.tipomensaje_id!.nombre}
                          className="cajabordeabajo"
                        />
                      </Form>
                    </Col>
                    <Col sm={6} className="minimocolumna">
                      <Form.Label>Fecha estimada de Publicación</Form.Label>
                      <Form className="d-flex">
                        <Form.Control
                          type="search"
                          placeholder=""
                          aria-label="Search"
                          disabled={true}
                          value={moment(solicitud.fechaMensaje).format(
                            'DD/MM/YYYY'
                          )}
                          className="cajabordeabajo"
                        />
                      </Form>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    {solicitud ? (
                      tipoMensajes.map((tipomensaje, index) => (
                        <Col
                          key={tipomensaje.tipomensaje_id}
                          sm={12}
                          className="minimocolumna"
                        >
                          <Form.Label className="textonegro">
                            *{tipomensaje.nombre}:{' '}
                          </Form.Label>{' '}
                          <Form.Label>{tipomensaje.descripcion}</Form.Label>
                        </Col>
                      ))
                    ) : (
                      <Form.Label className="textonegro"></Form.Label>
                    )}
                  </Row>
                  <Row className="mt-3">
                    <Col sm={6} className="minimocolumna">
                      <Form.Label>Segmento</Form.Label>
                      <Form className="d-flex">
                        <Form.Control
                          type="search"
                          placeholder=""
                          aria-label="Search"
                          disabled={true}
                          value={
                            solicitud!.segmento
                              ? 'Un segmento especifivo de usuarios'
                              : 'Todo Prosa'
                          }
                          className="cajabordeabajo"
                        />
                      </Form>
                    </Col>
                  </Row>
                  {solicitud!.segmento ? (
                    <Row className="mt-3">
                      <a target="_blank" href={solicitud!.urlEnlaceSegmento} rel="noopener noreferrer">
                        <Col sm={12} className="minimocolumna">
                          <Form.Label>Enlace</Form.Label>
                          <Form className="d-flex">
                            <div className="material-icons me-2">link</div>
                            <Form.Label className="link-largo cursospointer">
                              {solicitud!.urlEnlaceSegmento}
                            </Form.Label>
                          </Form>
                        </Col>
                      </a>
                    </Row>
                  ) : (
                    ''
                  )}
                  <Row className="mt-3">
                    <Col sm={12} className="minimocolumna">
                      <Form.Label>Descripción</Form.Label>
                      <div className="contenido-espacio mb-3 cajabordeabajo">
                        {descripcionSolicitud}
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : (
                ''
              )}
            </Col>
          </Row>
        ) : (
          ''
        )}
      </div>
    </>
  );
};
